/**
 * Global domain route guard for admin routes
 */

export const isDomainAllowedForAdmin = (): boolean => {
  if (typeof window === 'undefined') return true;
  
  const currentHost = window.location.host;
  const mainHost = 'bedrive.inds.dev';
  
  // Only allow main domain and www subdomain
  return currentHost === mainHost || currentHost === `www.${mainHost}`;
};

export const isTenantRoute = (path?: string): boolean => {
  const currentPath = path || window.location.pathname;
  return currentPath.includes('/admin/tenants') || 
         currentPath.startsWith('/admin/tenants');
};

export const blockTenantDomainsFromTenantRoutes = () => {
  if (typeof window === 'undefined') return;
  
  const currentPath = window.location.pathname;
  const isMainDomain = isDomainAllowedForAdmin();
  const isTenantPath = isTenantRoute(currentPath);
  
  if (!isMainDomain && isTenantPath) {

    // Force redirect to admin home
    window.location.href = '/admin';
    throw new Error('Tenant management denied from tenant domains');
  }
};

// Enhanced domain guard that runs before tenant routes only
export const tenantRouteGuard = () => {
  blockTenantDomainsFromTenantRoutes();
  return null;
};